const RESET_SELECTED_ROLE = 'fulcrum/container/Admin/User/UserRole/RESET_SELECTED_ROLE'
const RESET_SELECTED_USER = 'fulcrum/container/Admin/User/UserRole/RESET_SELECTED_USER'
const UPDATE_SELECTED_USER = 'fulcrum/container/Admin/User/UserRole/UPDATE_SELECTED_USER'
const CHANGE_SELECTED_USER = 'fulcrum/container/Admin/User/UserRole/CHANGE_SELECTED_USER'
const CHANGE_SELECTED_ROLE = 'fulcrum/container/Admin/User/UserRole/CHANGE_SELECTED_ROLE'
const UPDATE_SELECTED_ROLE = 'fulcrum/container/Admin/User/UserRole/UPDATE_SELECTED_ROLE'
const POST_USER = 'fulcrum/container/Admin/User/UserRole/POST_USER'
const POST_USER_ERROR = 'fulcrum/container/Admin/User/UserRole/POST_USER_ERROR'
const POST_USER_START = 'fulcrum/container/Admin/User/UserRole/POST_USER_START'
const POST_USER_SUCCESS = 'fulcrum/container/Admin/User/UserRole/POST_USER_SUCCESS'

export {
  RESET_SELECTED_ROLE,
  RESET_SELECTED_USER,
  UPDATE_SELECTED_USER,
  CHANGE_SELECTED_USER,
  CHANGE_SELECTED_ROLE,
  UPDATE_SELECTED_ROLE,
  POST_USER,
  POST_USER_ERROR,
  POST_USER_START,
  POST_USER_SUCCESS,
}
